module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp3_3.bcbcd3e7.png";